import { ServicesQuery } from '../../../services/network/services-query';
import { CustomerByIdQuery } from '../../../customers/network/customer-by-id-query';
import { TimesheetQuery } from '../../network/timesheet-query';
import { AddAppointmentMutation } from '../../network/add-appointment-mutation';
import { AddWalkInClientMutation } from './add-walk-in-client-mutation';
import { CustomerSearchService } from '../../../customers/network/customer-search-service';
import { WalkInListCurrentQuery } from './walk-in-list-current-query';
import { WalkInListHistoryQuery } from './walk-in-list-history-query';
import { RemoveWalkInClientMutation } from './remove-walk-in-client-mutation';
import { RestoreWalkInClientMutation } from './restore-walk-in-client-mutation';
import { AcceptWalkInSlotMutation } from './accept-walk-in-slot-mutation';
import { NotifyWalkInSlotMutation } from './notify-walk-in-slot-mutation';
import { UpdateWalkInListSettingsMutation } from './update-walk-in-list-settings-mutation';
import { WaitingListSettingsQuery } from './waiting-list-settings-query';
export var endpoints = {
    servicesQuery: new ServicesQuery(),
    customerByIdQuery: new CustomerByIdQuery(),
    timesheetQuery: new TimesheetQuery(),
    addAppointmentMutation: new AddAppointmentMutation(),
    addWalkInClientMutation: new AddWalkInClientMutation(),
    removeWalkInClientMutation: new RemoveWalkInClientMutation(),
    restoreWalkInClientMutation: new RestoreWalkInClientMutation(),
    customersSearchService: new CustomerSearchService(),
    walkInListCurrentQuery: new WalkInListCurrentQuery(),
    walkInListHistoryQuery: new WalkInListHistoryQuery(),
    acceptWalkInSlotMutation: new AcceptWalkInSlotMutation(),
    notifyWalkInSlotMutation: new NotifyWalkInSlotMutation(),
    updateWalkInListSettingsMutation: new UpdateWalkInListSettingsMutation(),
    waitingListSettingsQuery: new WaitingListSettingsQuery(),
};
